import React from 'react';

const BookingProcess = {
  title: 'Booking Process',
  items: [
    {
      header: 'How do I confirm a booking?',
      content: (
        <div>
          <p>If you receive a booking request from a traveler on your available date, you can click the ‘confirm’ button to accept the booking request. </p>
        </div>
      )
    },
    {
      header: 'What does the lightning symbol mean? / What is Instant Book?',
      content: (
        <div>
          <p>The lightning symbol means your trip is instantly available on that date. When a traveler books the trip, the booking will be automatically confirmed without the need for your manual confirmation.</p>
          <p>We suggest you set your trip date for Instant Book if you are sure you are available for a trip on that date.</p>
        </div>
      )
    },
    {
      header: 'What are the differences between Instant Availability and Availability upon Request?',
      content: (
        <div>
          <p>As you may know, the lightning symbol means that the trip is available for Instant Book. If you are still not sure if you will be available on the date, you can set it to Availability upon Request (white color). Travelers will still be able to book your trip, but they will have to wait for your manual confirmation first. Once you are sure you are available, you can confirm the booking and travelers will receive a manual confirmation.</p>
          <p>Tips: Most travelers are looking for trips with Instant Availability, but if you’re unsure, please set your trips for Availability upon Request. In this case, we suggest you give the traveler a reply as soon as possible in order to assure them that their booking request is acknowledged.</p>
        </div>
      )
    },
    {
      header: 'How do I reschedule a confirmed trip date?',
      content: (
        <div>
          <p>You can’t reschedule a confirmed trip date by yourself.</p>
          <p>If you need to reschedule it, please contact us at <a href="mailto:support@takemetour.com">support@takemetour.com</a> and provide us solid reason and proof of agreement with your traveler(s).</p>
        </div>
      )
    },
    {
      header: 'How can I know if a booking is confirmed?',
      content: (
        <div>
          <p>After the traveler completes the payment and you confirm the booking request, a confirmation email with the traveler’s personal contact information will be sent to your registered email address. </p>
        </div>
      )
    },
    {
      header: 'What should I do if I’m not available on the requested trip date?',
      content: (
        <div>
          <p>If you’re not available on the requested trip date, please try rescheduling the trip by clicking ‘reschedule the trip date’. Then select your available date and propose it to the traveler. Once the traveler accepts the proposed date, the booking will be automatically confirmed. </p>
          <p>If you cannot find an alternative date, you can click ‘cancel’. Please note that you can also cancel after the traveler books your trip.</p>
        </div>
      )
    },
    {
      header: 'When can I confirm a booking request?',
      content: (
        <div>
          <p>If you are available on an alternative date (the date that doesn’t match your availability calendar), you can confirm the booking right after receiving a traveler’s request. However, most travelers will want to chat with you and ask for further details first before proceeding with the payment. </p>
        </div>
      )
    },
    {
      header: 'How do I contact the traveler?',
      content: (
        <div>
          <p>We encourage you to communicate with travelers via our chat system. </p>
          <p>However, for security and privacy, any personal contact information (e.g. email address, phone number, social media account) exchanged prior to the booking confirmation will be blocked by our system and may get suspended if you try to send it to the traveler. </p>
        </div>
      )
    },
    {
      header: 'What is availability?',
      content: (
        <div>
          <p>Availability is one of the most important features on our system as it helps speed up travelers’ decision making. You can set your available dates on the calendar beforehand. By constantly updating your availability calendar, travelers can make instant bookings and proceed with the payment process right away. </p>
        </div>
      )
    },
    {
      header: 'How do I update my availability calendar?',
      content: (
        <div>
          <p>You can directly manage your calendar with our availability feature by simply clicking the button ‘Availability upon Request’, ‘Instant Availability’ or ‘Busy’. Then choose the dates according to your availability. </p>
          <p>You can access this feature either on our website or on our mobile application.</p>
          <ul>
            <li>
              <p>Access on our website: Job Management {'>'} <a href="https://www.takemetour.com/dashboard/availability" target="_blank" rel="noopener noreferrer">Manage Availability</a></p>
            </li>
            <li>
              <p>Access on our mobile application:</p>
              <p>Download the application for <a href="https://itunes.apple.com/th/app/local-expert-takemetour/id1276154805?mt=8" target="_blank" rel="noopener noreferrer">IOS</a></p>
              <p>Download the application for <a href="https://play.google.com/store/apps/details?id=com.takemetour.lx" target="_blank" rel="noopener noreferrer">Android</a></p>
            </li>
          </ul>
        </div>
      )
    },
    {
      header: 'Why is my message censored/withheld?',
      content: (
        <div>
          <p>For a safe and peaceful environment on TakeMeTour, we may withhold parts of your message or your entire message for 2 main reasons:</p>
          <ul>
            <li><p>The message contains personal contact information such as telephone number, email address, and social media account. It will be withheld from sending if you have confirmed the booking.</p></li>
            <li><p>The message contains vulgar and explicit content. </p></li>
          </ul>
        </div>
      )
    }
  ]
};

export default BookingProcess;
